import Phaser from 'phaser';
import { NPCMoveConfig, NPCMovePattern } from '../types/data';
import { NPCSprite } from './NPCSprite';

const DEFAULTS: Required<Pick<NPCMoveConfig, 'enabled' | 'pattern' | 'radius' | 'speed' | 'idleMs'>> = {
  enabled: true, pattern: 'wander', radius: 32, speed: 40, idleMs: 1200,
};

export class NPCBehaviorController {
  getSprite() { return this.sprite; }
  private origin: Phaser.Math.Vector2;
  private target?: Phaser.Math.Vector2;
  private waitUntil = 0;
  private config: Required<Pick<NPCMoveConfig, 'enabled' | 'pattern' | 'radius' | 'speed' | 'idleMs'>> & Pick<NPCMoveConfig, 'points'>;
  private routeIndex = 0;
  private routeDirection = 1;
  constructor(private readonly scene: Phaser.Scene, private readonly sprite: NPCSprite, config?: NPCMoveConfig) {
    this.origin = new Phaser.Math.Vector2(sprite.x, sprite.y);
    this.config = { ...DEFAULTS, ...(config ?? {}) };
  }
  update(now: number) {
    if (!this.sprite.active || !this.sprite.scene) return;
    const body = this.sprite.body as Phaser.Physics.Arcade.Body | undefined;
    if (!this.config.enabled || !body) return;
    if (this.config.pattern === 'idle') { body.setVelocity(0,0); this.sprite.playIdle(); return; }
    if (now < this.waitUntil) { body.setVelocity(0,0); this.sprite.playIdle(); return; }
    if (!this.target || Phaser.Math.Distance.Between(this.sprite.x, this.sprite.y, this.target.x, this.target.y) < 6) {
      this.pickTarget(now); body.setVelocity(0,0); this.sprite.playIdle(); return;
    }
    const vec = new Phaser.Math.Vector2(this.target.x - this.sprite.x, this.target.y - this.sprite.y).normalize().scale(this.config.speed);
    body.setVelocity(vec.x, vec.y); this.sprite.updateFacing(vec.x, vec.y);
  }
  private pickTarget(now: number) {
    this.waitUntil = now + Phaser.Math.Between(Math.floor(this.config.idleMs * 0.75), Math.floor(this.config.idleMs * 1.35));
    this.target = this.resolveNextTarget(this.config.pattern);
  }
  private resolveNextTarget(pattern: NPCMovePattern): Phaser.Math.Vector2 {
    if ((pattern === 'patrol' || pattern === 'pingpong') && this.config.points && this.config.points.length > 0) {
      const points = this.config.points; const point = points[this.routeIndex % points.length];
      if (pattern === 'patrol') this.routeIndex = (this.routeIndex + 1) % points.length;
      else if (points.length > 1) { if (this.routeIndex >= points.length - 1) this.routeDirection = -1; if (this.routeIndex <= 0) this.routeDirection = 1; this.routeIndex += this.routeDirection; }
      return new Phaser.Math.Vector2(point.x, point.y);
    }
    return new Phaser.Math.Vector2(this.origin.x + Phaser.Math.Between(-this.config.radius, this.config.radius), this.origin.y + Phaser.Math.Between(-this.config.radius, this.config.radius));
  }
}
